export interface IUnifiedClassAssessments {
  assessmentId: number;
  skillId: number;
  assessmentName: string;
  assessmentSeq: number;
}

export class UnifiedClassAssessments implements IUnifiedClassAssessments {
  assessmentId;
  skillId;
  assessmentName;
  assessmentSeq;

  constructor(config: IUnifiedClassAssessments) {
    this.assessmentId = config.assessmentId;
    this.skillId = config.skillId;
    this.assessmentName = config.assessmentName;
    this.assessmentSeq = config.assessmentSeq;
  }
}
